import { render, staticRenderFns } from "./BpFixedAssetsToNetWorthRatioDisplayer.vue?vue&type=template&id=4c3c3485"
import script from "./BpFixedAssetsToNetWorthRatioDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpFixedAssetsToNetWorthRatioDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports